<template>
 <div class="invalid-wrap">
  </div>
  <router-view />
</template>

<script>

export default {

  components: {    
  },
  data() {
    return {            
    };
  },
}
</script>


<style>

* {
  box-sizing: border-box;
}

/* 1. IMPORT CZCIONKI I ZMIENNE */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

:root {
  --orange: #f58232;
  --orange-dark: #ea580c;
  --blue: #0173bc;
  --blue-dark: #0056b3;
  --purple: #764ba2;
  --red: #dc3545;
  --bg-page: #f0f4f9;
  --bg-card: #ffffff;
  --border: #e5e7eb;
  --text-main: #1a2233;
  --text-muted: #6b7280;
  --text-theader: #606266;
  --sidebar-width: 260px;
  --dp-border-radius: 8px !important;
}

/* 2. RESET I PODSTAWY */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif;
  background-color: var(--bg-page);
  color: var(--text-main);
}

h3 {
  font-size: 24px;
  margin: 16px 0;
}

h4 {
  font-size: 18px;
  margin: 10px 0;
}

.text-center {
    text-align: center !important;
}

.app-icon {
    border: 1px solid #676767;
    border-radius: 5px;
    padding: 3px 4px 1px 4px;
    background-color: var(--orange);
    color: #fff;
    margin: 0 2px;
    transition: all 0.2s;
    cursor: pointer;
}

.large-btn {
    padding: 6px 22px 4px 22px;
}

.l-case {
    text-transform: lowercase !important;
}


.app-icon:hover {
    background-color: var(--orange-dark);
}

.icon-blue {
    background-color: var(--blue) !important;
}

.icon-blue:hover {
    background-color: var(--blue-dark) !important;
}

.cs-card {
  background: var(--bg-card);
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  padding: 20px;
  position: relative;
}

.spec-btn {
  background: transparent;
    color: var(--orange);
    border: none;
    width: 26px;
    height: 26px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    padding: 0;
}

.spec-btn:hover {
    transform: scale(1.2);
}

.refresh-btn {
    position: absolute;
    right: 8px;
    bottom: 8px;
}

.btn-disabled {
    background-color: #ccc;
    cursor: not-allowed;
    color: #666;
}

.btn-disabled:hover {
    background-color: var(--text-muted) !important;   
}

.text-tooltip {
  margin: 0;
  margin-top: -10px;
  margin-bottom: 10px;
  font-size: 12px;
  color: var(--text-muted);
}

.small-inf {
    font-size: 12px;
    color: var(--text-muted);
}

table.vgt-table {
    font-size: 14px !important;
}

.vgt-inner-wrap {
  border-radius: 8px !important;
}

.vgt-global-search {    
    border-radius: 8px 8px 0 0;
}

.vgt-wrap__footer {    
    border-radius: 0 0 8px 8px;
    font-size: 14px !important;
}

.vgt-wrap__footer .footer__navigation,
.vgt-wrap__footer .footer__navigation__page-btn span {
    font-size: 14px !important;
}

.vgt-global-search,
.vgt-table thead th,
.vgt-wrap__footer {
    background: var(--bg-page) !important; 

}

.cs-filter {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
}

.filter-item {
    display: flex;
    align-items: center;
}

.filter-item-btn {
    display: flex;
    align-items: center;
}

label,
.filter-label {
  font-size: 14px;  
  color: var(--text-main);
  margin-right: 8px;
}

input, select {
  padding: 6px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: 0.2s;
}

input:focus, select:focus {
  border-color: var(--orange);
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.vue-select {
    border-radius: 8px !important;
    padding-left: 6px !important;
}

.vue-select.thin {
    padding: 2px 0px;
    border: 1px solid #ddd !important;
}

.vue-select,
.vue-select .vue-dropdown {
    border: 1px solid #ddd !important;
}

.vue-select .vue-dropdown-item {
    font-size: 14px !important;
}

body .vue-dropdown {
    z-index: 10000 !important;
}

.vue-dropdown-item.highlighted {
    background-color: var(--orange) !important;
}

.vue-dropdown-item.selected.highlighted {
    background-color: var(--orange-dark) !important;
}

.vue-select-header .icon.arrow-downward, 
.vue-select-header .icon.loading, 
.vue-select-input-wrapper .icon.loading, 
.vue-tag span {
    margin-right: 8px !important;
}


.tag-select ul {
    max-height: 142px !important;
    overflow-y: auto !important;
}

.actions-result {
    margin-right: auto;
    color: var(--blue);
}
.actions-result.error {
    color: var(--orange-dark);
}


/* Select Tag Styles */


  .tag-manager {
    width: 100%;
    padding: 20px;
    }

    .chips-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;
        min-height: 27px;
    }

    .chip {
        background-color: var(--blue);
        color: white;
        padding: 4px 12px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        font-size: 12px;
    }

    .remove-icon {
        margin-left: 8px;
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        line-height: 1;
    }

    .remove-icon:hover {
        color: var(--blue-dark);
    }

    .input-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .input-group label {
        font-size: 13px;
        font-weight: 500;
        color: var(--text-main);
    }

    .input-group .vue-select {
        width: 100%;
    }

    /* Limit dropdown height to prevent overflow */
    .tag-manager .vue-dropdown,
    .assignment-list .vue-dropdown,
    .tag-select ul,
    .format-select ul {
        max-height: 142px !important;
        overflow-y: auto !important;
    }

    .save-btn {
        margin-top: 15px;
        background: #00c853;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        width: 100%;
    }

    .save-btn:hover {
        background: #00a444;
    }


    .chip.all-tag {
      background-color: var(--orange) !important;
      color: white;
    }

    .chip.all-tag .remove-icon {
      color: white;
      /* display: none; */
    }



  /* Tab Navigation Styles */
  .tab-navigation {
    display: flex;
    /* gap: 8px; */
    margin-bottom: 10px;
    border-bottom: 2px solid var(--border);
    padding-bottom: 0;
  }

  .tab-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-muted);
    transition: all 0.2s ease;
    position: relative;
    bottom: -2px;
    border-radius: 8px 8px 0 0;
  }

  .tab-button:hover {
    color: var(--text-main);
    background-color: #fff7ed;
    border-bottom: 3px solid var(--border);

  }

  .tab-button.active {
    color: var(--orange);
    border-bottom-color: var(--orange);
  }

  .tab-button span {
    font-family: 'Inter', sans-serif;
  }

  .tab-placeholder {
    color: var(--text-muted);
    font-size: 14px;
    text-align: center;
    padding: 40px 20px;
    font-style: italic;
  }


  /* Dialog Form Styles */
  .dialog-form {
    width: 100%;
  }

  .dialog-form .vue-select {
    width: 100%;
  }

  
  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
  }

  .form-row:last-child {
    margin-bottom: 0;
  }

  .form-row-flex {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-bottom: 20px;
    justify-content: flex-start;
    align-items: center;
    
  }

  .form-row-flex:last-child {
    margin-bottom: 0;
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .form-group-full {
    grid-column: 1 / -1;
  }

  .form-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 8px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    display: block;
  }

 
  .small-label {
    font-size: 11px !important;    
  }

  .form-label a {
    color: var(--orange);
    text-decoration: none;
    margin-left: 5px;
    font-size: 10px;
  }

  .form-input {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid var(--border);
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    color: var(--text-main);
    background-color: var(--bg-card);
    transition: all 0.2s ease;
    outline: none;
  }

  .form-input-select {
    border-radius: 8px;
    padding: 7px 0;
  }

  .form-input:focus {
    border-color: var(--orange);
    box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
  }

  
  .readonly-field {
    background-color: var(--bg-page);
    color: var(--text-muted);
    cursor: not-allowed;
    font-weight: 500;
  }

  .readonly-field:focus {
    border-color: var(--border);
    box-shadow: none;
  }

  .status-indicator {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .status-indicator .form-input {
    flex: 1;
  }

  .live-badge {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    background-color: #9ca3af;
    color: white;
    text-transform: uppercase;
    transition: all 0.3s ease;
  }

  .live-badge.is-live {
    background-color: #ef4444;
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .form-row {
      grid-template-columns: 1fr;
      gap: 16px;
    }

    .form-group-full {
      grid-column: 1;
    }
  }


.cs-animation {
    animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}


</style>
